module.exports = __webpack_public_path__ + "static/hero-902d0f70100d4e3aaf79001d24e35411.png";